import React, { Component } from "react";
import { Tabs } from 'antd';
import { Route, Redirect } from 'react-router-dom';
import ChurchTab from './church/churchPage.js';
import GroupTab from './group/groupPage.js';
import { activeSubPath } from "../../../utilities/routes";
import './statisticsPage.css';

export default class StatisticsPage extends Component {
  onTabChange = (key) => this.props.history.push(key);
  tabPath = (name) => `${this.props.match.url}/${name}`;

  render() {
    return (
      <div className="card-container statistics-page">
        <Route exact path={`${this.props.match.url}`} render={() => <Redirect to={`${this.tabPath('church')}`} />} />

        <Tabs className="dashboard-main-tabs" type="card" animated={true}
              activeKey={`${activeSubPath(this.props.location.pathname, 'stats')}`} onChange={this.onTabChange}>
          <Tabs.TabPane tab="Church" key={`${this.tabPath('church')}`}>
            <Route path={`${this.tabPath('church')}`} render={() => <ChurchTab {...this.props} />} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Group" key={`${this.tabPath('group')}`}>
            <Route path={`${this.tabPath('group')}`} render={() => <GroupTab {...this.props} />} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/statistics/statisticsPage.js